import React from 'react'
import { useSelector } from 'react-redux'
import { State } from '../../../../types/state'

interface CollaboratorsModalProps {
  show: boolean
  onClose: () => void
  newCollaboratorEmail: string
  setNewCollaboratorEmail: (email: string) => void
  newRole: string
  setNewRole: (role: string) => void
  projectCollaboratorsLength: number
  onAddCollaborator: () => void
  newFirstName: string
  setNewFirstName: (firstName: string) => void
  newLastName: string
  setNewLastName: (lastName: string) => void
}

export const CollaboratorsModal: React.FC<CollaboratorsModalProps> = ({
  show,
  onClose,
  newCollaboratorEmail,
  setNewCollaboratorEmail,
  newRole,
  setNewRole,
  projectCollaboratorsLength,
  onAddCollaborator,
  newFirstName,
  setNewFirstName,
  newLastName,
  setNewLastName
}) => {
  const { packageUsersNumber } = useSelector((state: State) => state.user)
  if (!show) return null

  return (
    <div className='modal fade show' style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Dodaj członka zespołu</h5>
            <button
              type='button'
              className='close'
              onClick={onClose}
            >
              <span>&times;</span>
            </button>
          </div>
          <div className='modal-body'>
            {packageUsersNumber && (
              <div className='alert alert-info mb-3'>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Limit użytkowników w pakiecie:</span>
                  <span className='font-weight-bold'>
                    {projectCollaboratorsLength + 1} / {packageUsersNumber}
                  </span>
                </div>
                {projectCollaboratorsLength + 1 >= packageUsersNumber && (
                  <div className='mt-2 text-danger'>
                    Osiągnięto limit użytkowników w pakiecie. Aby dodać więcej członków zespołu, rozważ aktualizację pakietu.
                  </div>
                )}
              </div>
            )}
            <div className='form-group'>
              <label>Email</label>
              <input
                type='email'
                className='form-control'
                placeholder='Wprowadź adres email'
                value={newCollaboratorEmail}
                onChange={(e) => setNewCollaboratorEmail(e.target.value)}
                disabled={!!packageUsersNumber && projectCollaboratorsLength + 1 >= packageUsersNumber}
              />
            </div>
            <div className='form-group'>
              <label>Imię</label>
              <input
                type='text'
                className='form-control'
                placeholder='Wprowadź imię'
                value={newFirstName}
                onChange={(e) => setNewFirstName(e.target.value)}
              />
            </div>
            <div className='form-group'>
              <label>Nazwisko</label>
              <input
                type='text'
                className='form-control'
                placeholder='Wprowadź nazwisko'
                value={newLastName}
                onChange={(e) => setNewLastName(e.target.value)}
              />
            </div>
            <div className='form-group'>
              <label>Rola</label>
              <input
                type='text'
                className='form-control'
                placeholder='Wprowadź rolę członka zespołu'
                value={newRole}
                onChange={(e) => setNewRole(e.target.value)}
                disabled={!!packageUsersNumber && projectCollaboratorsLength + 1 >= packageUsersNumber}
              />
            </div>
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className={`
                  tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                  tw-text-white
                  tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-red-500 hover:tw-bg-opacity-90 focus:tw-bg-red-500
                `}
              onClick={onClose}
            >
              Anuluj
            </button>
            <button
              type='button'
              className={`
                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                      tw-text-white
                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                    `}
              onClick={onAddCollaborator}
              disabled={!newCollaboratorEmail.trim() || !newRole.trim()}
            >
              Dodaj
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
